<template>
    <div>
        <v-dialog v-model="pmassessmentrecorddetaildialog" max-width="1200px">
            <v-card>
                <v-card-title>
                    {{ formData.staffcode && formData.staffname 
                        ? $t('pmassementrecord.editassessmentresult', {
                            code: formData.staffcode,
                            name: formData.staffname
                        })
                        : 'Loading...'
                    }}
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>                                    
                            <v-col cols="12" sm="12" md="12" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.staffname')"
                                    type="text"
                                    v-model="formData.staffname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" sm="5" md="5" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    v-model="formData.staffcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1" sm="1" md="1" class="mt-n4">
   
                            </v-col>
                            <v-col cols="6" sm="6" md="6" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="formData.companyname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('appraisalrecord.periodfrom')"
                                    type="date"
                                    v-model="formData.startdate"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('appraisalrecord.perioduntil')"
                                    type="date"
                                    v-model="formData.enddate"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmassementrecord.finalscore')"
                                    type="text"
                                    v-model="formData.finalscore"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('Setuprankmapset.rank')"
                                    type="text"
                                    v-model="formData.rank"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmassementrecord.finalrank')"
                                    type="text"
                                    :items="ratingList"
                                    hide-selected
                                    :rules="[rules.required]"
                                    v-model="formData.finalrank"
                                    item-value="value"
                                    item-text="text"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmAssessmentRecordDetailInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmAssessmentRecordDetailInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pmassessmentrecorddetailreviewerdialog" max-width="1200px">
            <v-card>
                <v-card-title>
                    {{ formData.staffcode && formData.staffname 
                        ? $t('pmassementrecord.assessmentdetails', {
                                code: formData.staffcode,
                                name: formData.staffname
                            })
                        : 'Loading...'
                    }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row v-if="reviewerList.length > 0">
                            <v-col cols="12" v-for="(reviewer, index) in reviewerList" :key="index">
                                <v-card class="pa-4 yellow lighten-4">
                                    <v-row v-for="(field, fieldKey) in getReviewerFields(reviewer)" :key="fieldKey">
                                        <v-col cols="4" class="text-left">{{ field.label }}</v-col>
                                        <v-col cols="8" class="font-weight-bold">{{ field.value }}</v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" class="text-center">
                                <v-alert type="warning">No reviewer data found.</v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{ errMsg }}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmAssessmentRecordDetailReviewerInput">
                        {{$t('button.cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar color="#ECEFF1">
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-btn text @click="getCSV" class="mr-5">
                    <v-icon>mdi-export</v-icon>
                </v-btn>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    style="width: 250px"
                    class="pr-5 pt-3"
                    hide-details
                >
                </v-text-field>
            </v-toolbar-items>
        </v-toolbar>
        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elavation-1"
:sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <img 
                    :src="`${publicPath}images/paper.svg`" 
                    alt="SVG Icon"
                    @click="onAdvanceEditItem(item)" 
                    style="cursor: pointer;"
                    class="ml-2 mr-2"
                />
                <v-icon
                    small
                    class="ml-2 mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-2 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            search: "",
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            pmassessmentrecorddetaildialog: false,
            pmassessmentrecorddetailreviewerdialog: false,
            detailItem: this.parentObject.detailItem,

            formData: {
                id: null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                staffname: null,
                staffcode: null,
                companyname:null,
                finalscore: null,
                rank:null,
                finalrank: null,
                startdate: null,
                enddate: null,
                updatedby: this.$store.getters.userId,
                rectimestamp: null,
                stamp: null,
                
            },
            ratingList: [],
            ratingFullItem:[],
            reviewerList: [], // advanced edit to see reviwer
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm:'',
            selectedItem: null, 
        }
    },

    methods: {
        modifyItemHandler(item) {
            if (!item) {
                console.error("⚠️ No item selected for modification!");
                return;
            }
            this.isEdit = true;
            // Assign item data safely
            this.formData = {
                ...item,
                startdate: this.parentObject?.startdate || "N/A", //assessment record startdate
                enddate: this.parentObject?.enddate || "N/A",   //assessment record enddate
                staffname: item.staffname || "N/A",
                staffcode: item.staffcode || "N/A",
                companyname: item.companyname || "N/A",
                finalrank: item.finalrank ? String(item.finalrank) : null, // Convert to string for v-autocomplete
                // stamp: item.
            };
            // Ensure Vue updates the form correctly
            this.$nextTick(() => {
                this.pmassessmentrecorddetaildialog = true;
            });
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('pmassementrecord.deleteresultconfirm', { name: item.staffname });
            this.selectedItem = item;
            this.isConfirm=true;
            
        },

        deleteItemHandlerAction(){

            if (!this.selectedItem) {
                console.error(" No item selected for deletion!");
                return;
            }
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                console.error("❌ No permission to delete");
                return false;
            }

            this.$store.dispatch('delete', {
                url: "/performanceassessmentrecorddetail/"+ vm.selectedItem.id // Send ID as a parameter
            })
            .then(() => {
                const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }
                vm.selectedItem = null; // 🔹 Clear after deletion
            })
            .catch((err) => {
                console.error("❌ Error deleting:", err);
                vm.errMsg = err;
            });
            
            this.isConfirm = false;  // 🔹 Close confirmation dialog
        },
        
        async onAdvanceEditItem(item) { //load the reviewer detail
            if (!item) {
                console.error("⚠️ No item selected!");
                return;
            }

            this.isEdit = true;
            this.formData = {
                ...item,
                staffname: item.staffname || "N/A",
                staffcode: item.staffcode || "N/A",
            };

            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewersname/${item.pmassessmentrecordid}/${item.staffid}`
                });

                if (res.data && res.data.reviewers) {
                    this.reviewerList = res.data.reviewers.map(reviewer => ({
                        ...reviewer,
                        reviewfromdate: reviewer.reviewfromdate
                            ? moment(reviewer.reviewfromdate).format('YYYY-MM-DD')
                            : null,
                        reviewuntildate: reviewer.reviewuntildate
                            ? moment(reviewer.reviewuntildate).format('YYYY-MM-DD')
                            : null,
                    }));

                } else {
                    console.warn("⚠️ No reviewers found!");
                    this.reviewerList = [];
                }
            } catch (err) {
                console.error("❌ Error fetching reviewers:", err);
                this.reviewerList = [];
            }

            this.$nextTick(() => {
                this.pmassessmentrecorddetailreviewerdialog = true;
            });
        },

        async savePmAssessmentRecordDetailInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }
                    const res = await this.$store.dispatch('put', {
                        url: "/performanceassessmentrecorddetail/" + this.formData.id,
                        payload: this.formData // we only update the finalrank
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {//completed update
                        const updatedRecord = res.data.updatedRecord;

                        // 🔄 **Update UI without reloading**
                        // Find index
                        const index = this.detailItem.findIndex(item => item.id === updatedRecord.id);
                        if (index !== -1) {
                            // 🌟 Merge only fields from updatedRecord
                            this.$set(this.detailItem, index, {
                                ...this.detailItem[index], // keep existing UI fields
                                ...updatedRecord           // overwrite only the updated fields
                            });
                        }
                        this.pmassessmentrecorddetaildialog = false;
                        this.isEdit = false;
                        this.resetSelections();

                        // ✅ **Emit event to notify parent to reload summary**
                        this.$emit("updateSummary");
                    }
                }
            } catch (err) {
                // ✅ **Handle 409 Conflict Error Gracefully**
                if (err.response && err.response.status === 409) {
                    this.isErr = true;
                    this.errMsg = "⚠️ The record has been modified recently. Please refresh and try again.";
                } else {
                    this.isErr = true;
                    this.errMsg = err.message || "❌ An unexpected error occurred.";
                }
                console.error("❌ Error in processing:", err);
            }
        },

        closePmAssessmentRecordDetailInput() {
            this.pmassessmentrecorddetaildialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },

        closePmAssessmentRecordDetailReviewerInput() {
            this.pmassessmentrecorddetailreviewerdialog = false;
            this.isErr = false;
            this.isEdit = false;
        },

        resetSelections() {
            this.formData = {
                id:null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                updatedby: this.$store.getters.userId,

                pmassessmentrecorddetaildialog: false,
         
            }
        },

        async loaRankMapSetOption()
        {   
            const vm = this;
            this.$store.dispatch('get', {url: "/rankmapsetdetails/" + this.parentObject.ratingid})
            .then(function (res) {
                vm.ratingFullItem = res.data.rec;

                vm.ratingList = []; // Clear before populating
                for (let i = 0; i < vm.ratingFullItem.length; i++) {
                    vm.ratingList.push({
                        text: vm.ratingFullItem[i].rank,
                        value: String(vm.ratingFullItem[i].rank),//  Convert to string
                    });
                }
            })
            .catch(function (err) {
                vm.errMsg = err;
                console.error("❌ Error loading Ranking set detail", err);
            });
        },

        //This 3 is method use to export CSV
        objectToCSV(data) {
        const csvRows = [];

        //get header
        const headers = Object.keys(data[0]);
        //const headers = this.titles
        csvRows.push(headers.join(","));

        //loop over the rows
        for (const row of data) {
            const values = headers.map((header) => {
            const escaped = ("" + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
        }
        return csvRows.join("\n");
        },
        download(data) {
        const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", this.parentObject.pageTitle + ".csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        },
        async getCSV() {
        let titles = this.parentObject.tabHeader;
        let item = this.detailItem;
        let data = [];
        let obj2 = {};

        titles.forEach((element1) => {
            let x = element1.text;
            obj2[x] = element1.value;
        });

        item.forEach((element1) => {
            let obj = {};
            titles.forEach((element2) => {
            if (element2.value != "action") {
                let key = element2.text;
                obj[key] = element1[element2.value];
            }
            });
            data.push(obj);
        });

        const csvData = this.objectToCSV(data);
        this.download(csvData);
        },

        getReviewerFields(reviewer) {
            return [
            {
                label: this.$t('appraisalrecord.reviewer'),
                value: `${reviewer.reviewerstaffcode} - ${reviewer.reviewername}`
            },
            {
                label: this.$t('pmassementrecord.reviewperiod'),
                value: `${reviewer.reviewfromdate} to ${reviewer.reviewuntildate}`
            },
            {
                label: this.$t('appraisalrecord.factor'),
                value: reviewer.factor
            },
            {
                label: this.$t('Setupratingscaleset.score'),
                value: `${reviewer.score}%`
            }
            ];
        }
    },

    async mounted() {
        try {
            await this.loaRankMapSetOption();
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },

}
</script>